import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vehicleSubmissionsAPI = createApi({
    reducerPath: "vehicleSubmissionsAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllVehicleSubmissions: builder.mutation({
            query: ({ page, size, type }) => {
                let apiUrl = `/vehicle-submissions?page=${page + 1}&size=${size}&status=PENDING`;

                if (type) {
                    apiUrl += `&type=${type}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["vehicleSubmissions"],
        }),
        getVehicleSubmissionById: builder.mutation({
            query: ({ id }) => ({
                url: `/vehicle-submissions/${id}`,
                method: "GET"
            }),
            transformResponse: (response) => response,
        }),

        reviewVehicleSubmission: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vehicle-submissions/${id}/review`,
                method: "PATCH",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["vehicleSubmissions"]
        }),
    }),
});

export const {
    useGetAllVehicleSubmissionsMutation,
    useGetVehicleSubmissionByIdMutation,

    useReviewVehicleSubmissionMutation
} = vehicleSubmissionsAPI;

export default vehicleSubmissionsAPI;